/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_To_All_Event_Groups_HelpInputs */

const en_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply timecode conversion to all Event Groups (checked) or to the selected Event Group (unchecked)`)
};

const fr_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appliquer la conversion du timecode à tous les groupes d’événements (coché) ou au groupe sélectionné (non coché)`)
};

const de_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodekonvertierung auf alle Ereignisgruppen anwenden (aktiviert) oder auf die ausgewählte Ereignisgruppe anwenden (deaktiviert)`)
};

const it_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applica la conversione del timecode a tutti i gruppi di eventi (selezionato) o al gruppo di eventi selezionato (deselezionato)`)
};

const ru_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Применить преобразование временного кода ко всем группам событий (отмечено) или к выбранной группе событий (снято).`)
};

const es_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar conversión de código de tiempo a todos los grupos de eventos (marcado) o al grupo de eventos seleccionado (desmarcado)`)
};

const zh_cn2_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将时间码转换应用于所有事件组（已选中）或应用于选定的事件组（未选中）`)
};

const ja_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード変換をすべてのイベント グループに適用する（チェックあり）または選択したイベント グループに適用する（チェックなし）`)
};

const hi_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी इवेंट समूहों पर टाइमकोड रूपांतरण लागू करें (चुना हुआ) या चयनित इवेंट समूह पर (चुना हुआ नहीं)`)
};

const pt_pt2_apply_to_all_event_groups_help = /** @type {(inputs: Apply_To_All_Event_Groups_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aplicar conversão de código de tempo a todos os Grupos de Eventos (marcado) ou ao Grupo de Eventos selecionado (desmarcado)`)
};

/**
* | output |
* | --- |
* | "Apply timecode conversion to all Event Groups (checked) or to the selected Event Group (unchecked)" |
*
* @param {Apply_To_All_Event_Groups_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_to_all_event_groups_help = /** @type {((inputs?: Apply_To_All_Event_Groups_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_To_All_Event_Groups_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_apply_to_all_event_groups_help(inputs)
	if (locale === "de") return de_apply_to_all_event_groups_help(inputs)
	if (locale === "it") return it_apply_to_all_event_groups_help(inputs)
	if (locale === "ru") return ru_apply_to_all_event_groups_help(inputs)
	if (locale === "es") return es_apply_to_all_event_groups_help(inputs)
	if (locale === "zh-CN") return zh_cn2_apply_to_all_event_groups_help(inputs)
	if (locale === "ja") return ja_apply_to_all_event_groups_help(inputs)
	if (locale === "hi") return hi_apply_to_all_event_groups_help(inputs)
	if (locale === "pt-PT") return pt_pt2_apply_to_all_event_groups_help(inputs)
	return en_apply_to_all_event_groups_help(inputs)
});